/*
  A taxonomy-filter Vue 3 app!

  Vue 3: https://vuejs.org/guide/introduction.html 
  (select 'Composition' as your API preference)

  Build tasks:
    gulp pageList
    npm run pageList

  Watch task:
    gulp watchPageList

  Config file:
    vite.config.pageList.js
*/
import { createApp } from 'vue';
import App from './pageList/App.vue';

createApp(App).mount("#tzo-page-list-app");
